import { render, staticRenderFns } from "./AIChatDashboard.vue?vue&type=template&id=5c369898&"
import script from "./AIChatDashboard.vue?vue&type=script&lang=js&"
export * from "./AIChatDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports